module.exports = __webpack_public_path__ + "img/robot.938e5b6f.png";